
<template>
  <div>
    <header-slot>
      <template v-slot:content-right> </template>
    </header-slot>

    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view ref="routerViewTab" :key="routerName" />
    </b-card>
  </div>
</template>

<script>
export default {
  computed: {
    routerName() {
      return this.$route.matched[2].name;
    },
  },
};
</script>




